import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showAddProjectModal: false,
  addProjectForm: {
    brandName: '',
    brandUrl: '',
    selectedCountries: [],
    primaryCountry: '',
    selectedVerticals: [],
    countrySearch: '',
    showCountryDropdown: false,
    errors: {},
    successMessage: ''
  }
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    setShowAddProjectModal: (state, action) => {
      state.showAddProjectModal = action.payload;
    },
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.addProjectForm[field] = value;
    },
    setFormErrors: (state, action) => {
      state.addProjectForm.errors = action.payload;
    },
    clearFormError: (state, action) => {
      const field = action.payload;
      delete state.addProjectForm.errors[field];
    },
    setSuccessMessage: (state, action) => {
      state.addProjectForm.successMessage = action.payload;
    },
    addSelectedCountry: (state, action) => {
      const countryCode = action.payload;
      if (!state.addProjectForm.selectedCountries.includes(countryCode)) {
        state.addProjectForm.selectedCountries.push(countryCode);
        // Auto-set primary if first country or primary not set
        if (state.addProjectForm.selectedCountries.length === 1 || !state.addProjectForm.primaryCountry) {
          state.addProjectForm.primaryCountry = countryCode;
        }
      }
    },
    removeSelectedCountry: (state, action) => {
      const countryCode = action.payload;
      state.addProjectForm.selectedCountries = state.addProjectForm.selectedCountries.filter(
        c => c !== countryCode
      );
      // If removing primary, set to first remaining country
      if (state.addProjectForm.primaryCountry === countryCode) {
        state.addProjectForm.primaryCountry = state.addProjectForm.selectedCountries.length > 0
          ? state.addProjectForm.selectedCountries[0]
          : '';
      }
    },
    setPrimaryCountry: (state, action) => {
      state.addProjectForm.primaryCountry = action.payload;
    },
    addSelectedVertical: (state, action) => {
      const vertical = action.payload;
      if (!state.addProjectForm.selectedVerticals.includes(vertical)) {
        state.addProjectForm.selectedVerticals.push(vertical);
      }
    },
    removeSelectedVertical: (state, action) => {
      const vertical = action.payload;
      state.addProjectForm.selectedVerticals = state.addProjectForm.selectedVerticals.filter(
        v => v !== vertical
      );
    },
    resetForm: (state) => {
      state.addProjectForm = {
        brandName: '',
        brandUrl: '',
        selectedCountries: [],
        primaryCountry: '',
        selectedVerticals: [],
        countrySearch: '',
        showCountryDropdown: false,
        errors: {},
        successMessage: ''
      };
    }
  }
});

export const {
  setShowAddProjectModal,
  updateFormField,
  setFormErrors,
  clearFormError,
  setSuccessMessage,
  addSelectedCountry,
  removeSelectedCountry,
  setPrimaryCountry,
  addSelectedVertical,
  removeSelectedVertical,
  resetForm
} = modalsSlice.actions;

export default modalsSlice.reducer;